import { checkHttpStatus, parseJSON, expiredToken } from '../../utils/response';
import { errorResponse } from '../../utils/response';
import { UserCode } from '../../utils/users';

export function log(message) {
    return fetch('logerror/log', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            message: message,
            userCode: UserCode()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                if (response == "undefined") {
                    alert('undefined');
                }

                return response;
            } catch (e) {
                errorResponse(response);

                return false;
            }
        })
        .catch(error => {
            errorResponse(error);

            return false
        })
}